const getFm2ConfigName = (item, options) => {
  const fm2Options = options?.FM2ConfigType || [];
  const option = fm2Options.find(
    (currentOption) => currentOption.code === item.fmReceiverChannel2_Config
  );

  return option?.name || null;
};

export const buildG5ConfigItems = (items, options) =>
  items.map((item) => ({
    ...item,
    DeviceType: item.isMini === 1 ? 'Ultra' : 'Edge',
    fmReceiverChannel2_Config_name: getFm2ConfigName(item, options),
  }));

export const G5_CONFIG_UI_COLUMNS = [
  { key: 'ID', title: 'ID', width: 80, type: 'raw' },
  { key: 'DeviceID', title: 'Device ID', width: 140, type: 'raw' },
  { key: 'DeviceType', title: 'Device Type', width: 80, type: 'deviceType' },
  {
    key: 'LastStatusReportTime',
    title: 'Last Status Report Time',
    width: 140,
    type: 'lastStatusTime',
  },
  {
    key: 'SchedulerRefTime',
    title: 'Scheduler Ref Time',
    width: 140,
    type: 'schedulerRefTime',
  },
  {
    key: 'ConfigTimeZone',
    title: 'Config Time Zone',
    width: 160,
    type: 'raw',
  },
  {
    key: 'SchedulerCorrInterval',
    title: 'Scheduler Corr Interval',
    width: 80,
    type: 'raw',
  },
  {
    key: 'SchedulerCorrNumSamples',
    title: 'Scheduler Corr Num Samples',
    width: 80,
    type: 'raw',
  },
  {
    key: 'SchedulerNoiseInterval',
    title: 'Scheduler Noise Interval',
    width: 80,
    type: 'raw',
  },
  {
    key: 'SchedulerNoiseNumSamples',
    title: 'Scheduler Noise Num Samples',
    width: 80,
    type: 'raw',
  },
  {
    key: 'SchedulerNoiseTxTime',
    title: 'Scheduler Noise Tx Time',
    width: 80,
    type: 'raw',
  },
  {
    key: 'SchedulerWakeupBefor',
    title: 'Scheduler Wakeup Befor',
    width: 80,
    type: 'raw',
  },
  {
    key: 'SchedulerRandomDelay',
    title: 'Scheduler Random Delay',
    width: 80,
    type: 'raw',
  },
  {
    key: 'AudioRecordingDurationSec',
    title: 'Audio Recording Duration Sec',
    width: 80,
    type: 'raw',
  },
  {
    key: 'CorrelationAudioRecordingDurationSec',
    title: 'Correlation Audio Recording Duration Sec',
    width: 80,
    type: 'raw',
  },
  {
    key: 'CorrelationRadioRecordingDurationSec',
    title: 'Correlation Radio Recording Duration Sec',
    width: 80,
    type: 'raw',
  },
  {
    key: 'AudioReportEnabled',
    title: 'Audio Report Enabled',
    width: 80,
    type: 'audioReportEnabled',
  },
  {
    key: 'CorrelationAudioSamplingFrequency',
    title: 'Correlation Audio Sampling Frequency',
    width: 80,
    type: 'raw',
  },
  {
    key: 'FmReceiverChannel_10k',
    title: 'FM Receiver Channel 10k',
    width: 100,
    type: 'raw',
  },
  {
    key: 'FmReceiverChannel2_10k',
    title: 'FM Receiver Channel 2 10k',
    width: 100,
    type: 'raw',
  },
  {
    key: 'fmReceiverChannel2_Config_name',
    title: 'FM Receiver Channel 2 Config',
    width: 100,
    type: 'raw',
  },
  { key: 'LTEMode', title: 'LTE Mode', width: 140, type: 'raw' },
  { key: 'APN', title: 'APN', width: 80, type: 'raw' },
  { key: 'Server', title: 'Server', width: 100, type: 'server' },
  {
    key: 'FallbackServer',
    title: 'Fallback Server',
    width: 100,
    type: 'server',
  },
  {
    key: 'catm_packet_size',
    title: 'CATM Packet Size',
    width: 100,
    type: 'raw',
  },
  {
    key: 'catm_rx_timeout',
    title: 'CATM RX Timeout',
    width: 100,
    type: 'raw',
  },
  {
    key: 'catm_tx_timeout',
    title: 'CATM TX Timeout',
    width: 100,
    type: 'raw',
  },
  { key: 'catm_flags', title: 'CATM Flags', width: 100, type: 'raw' },
  {
    key: 'nbiot_packet_size',
    title: 'NBIOT Packet Size',
    width: 100,
    type: 'raw',
  },
  {
    key: 'nbiot_rx_timeout',
    title: 'NBIOT RX Timeout',
    width: 100,
    type: 'raw',
  },
  {
    key: 'nbiot_tx_timeout',
    title: 'NBIOT TX Timeout',
    width: 100,
    type: 'raw',
  },
  { key: 'nbiot_flags', title: 'NBIOT Flags', width: 100, type: 'raw' },
  {
    key: 'psm_catm_str',
    title: 'PSM CATM',
    width: 160,
    type: 'valueOrDash',
  },
  { key: 'psm_nb_str', title: 'PSM NB', width: 160, type: 'valueOrDash' },
  {
    key: 'fbr_threshold',
    title: 'FBR Threshold',
    width: 120,
    type: 'valueOrDash',
  },
  {
    key: 'fbr_test_count',
    title: 'FBR Test Count',
    width: 120,
    type: 'valueOrDash',
  },
  {
    key: 'fbr_idle_samples',
    title: 'FBR Idle Samples',
    width: 120,
    type: 'valueOrDash',
  },
  {
    key: 'fbr_max_alerts',
    title: 'FBR Max Alerts',
    width: 120,
    type: 'valueOrDash',
  },
  {
    key: 'random_backoff_connect',
    title: 'Random Backoff Connect',
    width: 80,
    type: 'raw',
  },
  {
    key: 'second_keepalive',
    title: 'Second Keepalive',
    width: 100,
    type: 'secondKeepalive',
  },
];

export const G5_CONFIG_EXPORT_ONLY_COLUMNS = [
  {
    key: 'LastConfigReportTime',
    title: 'Last Config Report Time',
    width: 140,
    type: 'dateTime',
  },
  { key: 'BatteryLevel', title: 'Battery Level', width: 100, type: 'raw' },
  {
    key: 'BatteryLevelPost',
    title: 'Battery Level Post',
    width: 100,
    type: 'raw',
  },
  {
    key: 'AccessTechnologyName',
    title: 'Access Technology',
    width: 120,
    type: 'raw',
  },
  { key: 'IEMI', title: 'IEMI', width: 120, type: 'raw' },
  { key: 'ICCID', title: 'ICCID', width: 160, type: 'raw' },
  {
    key: 'StatusTimeZone',
    title: 'Status Time Zone',
    width: 120,
    type: 'raw',
  },
  {
    key: 'HardwareRevision',
    title: 'Hardware Revision',
    width: 120,
    type: 'raw',
  },
  {
    key: 'FirmwareRevision',
    title: 'Firmware Revision',
    width: 120,
    type: 'raw',
  },
  { key: 'RSRQ_db', title: 'RSRQ db', width: 100, type: 'raw' },
  { key: 'RSRQ_dbOK', title: 'RSRQ db OK', width: 100, type: 'booleanOK' },
  { key: 'RSRP_dbm', title: 'RSRP dbm', width: 100, type: 'raw' },
  { key: 'RSRP_dbmOK', title: 'RSRP dbm OK', width: 100, type: 'booleanOK' },
  {
    key: 'StatusFmReceiverChannel_10k',
    title: 'Status FM Receiver Channel 10k',
    width: 140,
    type: 'raw',
  },
  {
    key: 'NoiseIntensityMinRMS',
    title: 'Noise Intensity Min RMS',
    width: 140,
    type: 'raw',
  },
  {
    key: 'NoiseIntensityGain',
    title: 'Noise Intensity Gain',
    width: 120,
    type: 'raw',
  },
];

export const G5_CONFIG_EXPORT_COLUMNS = [
  ...G5_CONFIG_UI_COLUMNS,
  ...G5_CONFIG_EXPORT_ONLY_COLUMNS,
];

export const formatG5ConfigAudioReportValue = (value) => {
  switch (value) {
    case 0:
      return 'No';
    case 1:
      return 'Yes';
    case 2:
      return 'Yes x2';
    default:
      return '';
  }
};

export const formatG5ConfigSecondKeepaliveValue = (value) => {
  if (value == null) {
    return '--';
  }

  return value ? 'Yes' : 'No';
};

export const formatG5ConfigServerValue = (value) =>
  value ? value.split('.')[0] : '--';

export const formatG5ConfigSchedulerRefTimeValue = (item) => {
  const { SchedulerRefTime, SchedulerRefTime5SecResolution } = item;

  if (SchedulerRefTime == null) {
    return '';
  }

  const secondsValue = SchedulerRefTime5SecResolution || 0;
  const totalSeconds = SchedulerRefTime * 10 * 60 + secondsValue * 5;
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
    2,
    '0'
  );
  const seconds = String(totalSeconds % 60).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
};

export const getG5ConfigExportValue = (column, item) => {
  switch (column.type) {
    case 'deviceType':
      return item.DeviceType;
    case 'lastStatusTime':
      return item[column.key] ? new Date(item[column.key]).toLocaleString() : '';
    case 'server':
      return formatG5ConfigServerValue(item[column.key]);
    case 'valueOrDash':
      return item[column.key] == null ? '--' : item[column.key];
    case 'audioReportEnabled':
      return formatG5ConfigAudioReportValue(item[column.key]);
    case 'secondKeepalive':
      return formatG5ConfigSecondKeepaliveValue(item[column.key]);
    case 'schedulerRefTime':
      return formatG5ConfigSchedulerRefTimeValue(item);
    case 'booleanOK':
      return item[column.key] ? 'Yes' : 'No';
    case 'dateTime':
      return item[column.key] ? new Date(item[column.key]).toLocaleString() : '';
    default:
      return item[column.key] == null ? '' : item[column.key];
  }
};
